export const CONTACT_NUMBERS = [process.env.REACT_APP_CONTACT_PHONE_PRIMARY, process.env.REACT_APP_CONTACT_PHONE_SECONDARY];
if (CONTACT_NUMBERS.some(number => !/^\d{10}$/.test(number || ""))) {
  throw new Error("Configure both public studio phone numbers in the frontend environment.");
}
export const CONTACT_EMAIL = "webbuilders.corporate@gmail.com";